import { render, staticRenderFns } from "./imagec.vue?vue&type=template&id=6325e4da&lang=pug"
import script from "./imagec.vue?vue&type=script&lang=js"
export * from "./imagec.vue?vue&type=script&lang=js"
import style0 from "./imagec.vue?vue&type=style&index=0&id=6325e4da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports